export enum InvoiceErrorCode {
    Success = 0,
    PartialSuccess = 8120,
    InitialSaveError = 8130
}
